module.exports = __webpack_public_path__ + "img/gn_09.262f1ab1.png";